import * as z from "zod";
import { discountRescueInput } from "./discount-rescue-shared";

export const getDiscountRescueSummaryMetrics = {
  name: "getDiscountRescueSummaryMetrics" as const,
  input: discountRescueInput,
  output: z.object({
    failedDiscountsDetected: z.number(),
    rescuesClaimed: z.number(),
    claimRate: z.number(),
    previousRescuesClaimed: z.number(),
    previousClaimRate: z.number(),
    // Order attribution (from the recovered-metrics mart). Revenue is in the
    // shop currency; the frontend formats it via CurrencyContext.
    impactedRevenue: z.number(),
    recoveredOrders: z.number(),
    avgRecoveredOrderValue: z.number(),
    previousImpactedRevenue: z.number(),
    previousRecoveredOrders: z.number(),
    previousAvgRecoveredOrderValue: z.number(),
  }),
};
